import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "resident_id",
    label: "Resident",
    required: true,
    showInTable: true,
    lookup: {
      table: "residents",
      labelField: "full_name",
      secondaryField: "resident_code",
    },
  },
  {
    name: "expense_date",
    label: "Date",
    type: "date",
    required: true,
    showInTable: true,
  },
  {
    name: "amount",
    label: "Amount (₹)",
    type: "number",
    required: true,
    showInTable: true,
  },
  { name: "hospital_name", label: "Hospital", showInTable: true },
  { name: "doctor_name", label: "Doctor" },
  { name: "description", label: "Description", type: "textarea" },
  {
    name: "payment_status",
    label: "Payment Status",
    type: "select",
    options: [
      { value: "pending", label: "Pending" },
      { value: "paid", label: "Paid" },
      { value: "partial", label: "Partial" },
    ],
    showInTable: true,
  },
  { name: "bill_url", label: "Bill URL", type: "url" },
];

export default function Page() {
  return (
    <AdminShell
      title="Medical Expenses"
      subtitle="Resident medical bills and treatments"
    >
      <ResourceTable
        table="resident_medical"
        title="Medical Record"
        fields={fields}
        searchFields={["hospital_name", "doctor_name", "resident_id"]}
      />
    </AdminShell>
  );
}
